"use strict";

const pt_BR = require("./locales/pt_BR.json");
const es = require("./locales/es.json");
const en = require("./locales/en.json");

const languages = {
  pt_BR,
  es,
  en
};

export default languages;
